import { Descriptions } from "@/components/v2";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { ServicePartnerTag } from "@rumble-it/common-lib/types/models/ServicePartnerTag.interface";
import { Button, Card } from "@rumbledirect/ui";
import { UseMutationResult } from "@tanstack/react-query";
import { Popconfirm, Space } from "antd";
import { Link } from "react-router-dom";

interface ServicePartnerTagDetailCardProps {
  servicePartnerTag: ServicePartnerTag | undefined;
  isLoading?: boolean;
  deleteMutation?: UseMutationResult<null, Error, void, unknown>;
}

export const ServicePartnerTagDetailCard = ({
  servicePartnerTag,
  isLoading,
  deleteMutation,
}: ServicePartnerTagDetailCardProps) => {
  return (
    <Card
      loading={isLoading}
      className="w-full"
      title="Tag"
      extra={
        <Space>
          <Link to={`/service-partners/tags/${servicePartnerTag?.id}/edit`}>
            <Button icon={<EditOutlined />} />
          </Link>
          <Popconfirm
            title="Tag verwijderen"
            description="Weet je zeker dat je de tag wilt verwijderen?"
            onConfirm={() => deleteMutation?.mutate()}
            okText="Ja"
            cancelText="Nee"
          >
            <Button
              loading={deleteMutation?.isPending}
              danger
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        </Space>
      }
    >
      <Descriptions
        items={[
          {
            label: "Naam",
            children: servicePartnerTag?.name,
          },
        ]}
      />
    </Card>
  );
};
